import * as classnames from 'classnames/bind'
import * as firebase from 'firebase'
import * as queryString from 'query-string'
import * as R from 'ramda'
import * as React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router'
import { CardContainer } from '../../components/Card'
import cardStyles from '../../components/Card/card.scss'
import BasicLayout from '../../layouts/BasicLayout'
import { dispatch, RootState, select, store } from '../../store'
import Panel from './../LecturePage/launch-panel'
import styles from './lecture-page.scss'
import LecturePageMain from './main'
import Preview from './preview'

const cx = classnames.bind({
  ...cardStyles,
  ...styles
})

interface IState {
  activeMain: boolean
  isContent: boolean
  isMobileLecture: boolean
}

interface IProps extends RouteComponentProps<any> { }

class LecturePage extends React.Component<IProps, IState> {
  // public static getDerivedStateFromProps = (nextProps: IProps, prevState: IState): IState | null => {
  //   const { match } = nextProps
  //   return null
  // }
  public state: IState = {
    activeMain: false,
    isContent: false,
    isMobileLecture: false
  }
  public handleMainActive = () => {
    this.setState({ activeMain: true })
  }
  public handleMainInactive = () => {
    this.setState({ activeMain: false })
  }
  public isMobileLecture = () => {
    this.setState({ isMobileLecture: true })
  }
  public isMobileLectureInactive = () => {
    this.setState({ isMobileLecture: false })
  }
  public handleContent = () => {
    this.setState({ isContent: !this.state.isContent })
  }
  public onMobileInactive = () => {
    this.handleMainInactive()
    this.handleContent()
    this.isMobileLectureInactive()
  }
  public countPageviews = async () => {
    const { location } = this.props
    const pathname = R.replace(/\//g, '_', location.pathname)
    const pageviewRef = await firebase
      .firestore()
      .collection('pageviews')
      .doc(pathname)
    const pageviewSnap = await pageviewRef.get()
    if (pageviewSnap.exists) {
      pageviewRef.update({ count: pageviewSnap.get('count') + 1 })
    } else {
      pageviewRef.set({ pathname, count: 1 })
    }
  }
  public componentDidMount = async () => {
    this.countPageviews()
    this.onSetContentState(this.props)
  }
  public componentWillReceiveProps = (nextProps: IProps) => {
    this.countPageviews()
    this.onSetContentState(nextProps)
  }
  public onSetContentState = (props: IProps) => {
    const { match } = props
    const lectureId: string = match.params.lectureId
    dispatch.lectureContent.changeCurrentLecture(lectureId)
    dispatch.stats.fetchStats(lectureId)
  }
  public render() {
    const rootState = store.getState()
    const { match, location } = this.props
    const { activeMain, isContent, isMobileLecture } = this.state
    const lectureId: string = match.params.lectureId
    const queries = queryString.parse(location.search)
    const activeInsightId: string = queries.insightId as string
    const activeMaterialIdx: number = parseInt(
      queries.materialIdx as string,
      10
    )
    const lecture = select.lectures.getById(rootState, lectureId)
    const participants = select.participants.getByLectureId(
      rootState,
      lectureId
    )
    const currentUser = firebase.auth().currentUser
    const isSpeaker =
      lecture !== null &&
      currentUser !== null &&
      R.contains(currentUser.uid, lecture.speakerIds)
    const isParticipant =
      currentUser !== null &&
      participants !== null &&
      R.contains(currentUser.uid, participants)

    return (
      <BasicLayout className={cx('lecture-container')} noFooter={true}>
        <div className={cx('container')}>
          <div className={cx('row')}>
            <div className={cx('col-lg-8', 'order-2', 'order-lg-1')}>
              {/* <!-- when mobile open lecture main with adding an "active" class --> */}

              {isContent ? (
                <LecturePageMain
                  activeInsightId={activeInsightId}
                  activeMaterialIdx={activeMaterialIdx}
                  lectureId={lectureId}
                  onInactive={this.handleMainInactive}
                  active={activeMain}
                />
              ) : isMobileLecture === true ? (
                <LecturePageMain
                  activeInsightId={activeInsightId}
                  activeMaterialIdx={activeMaterialIdx}
                  lectureId={lectureId}
                  onInactive={this.onMobileInactive}
                  active={activeMain}
                />
              ) : (
                    <Preview isEdit={false} lectureId={lectureId} />
                  ) // <div>Preview</div>
              }
            </div>
            <div className={cx('col-lg-4', 'order-1', 'order-lg-2')}>
              <CardContainer className={cx('page-Lecture-c__aside')}>
                <Panel
                  lectureId={lectureId}
                  isSpeaker={isSpeaker}
                  isEdit={false}
                  isContent={isContent}
                  handleMainActive={this.handleMainActive}
                  mobileLectureContent={this.isMobileLecture}
                  onhandleContent={this.handleContent}
                  isParticipant={isParticipant}
                />
              </CardContainer>
            </div>
          </div>
        </div>
      </BasicLayout>
    )
  }
}

const mapState = ({ lectures, auth }: RootState) => ({
  lectures,
  auth
})

export default connect(mapState)(LecturePage)



// WEBPACK FOOTER //
// ./src/pages/LecturePage/index.tsx